import { connect } from 'react-redux';
import { Breadcrumb, Card, Icon, List, Menu } from 'semantic-ui-react';
import PageContainer from '../common/PageContainer';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import AddOrganizationDialog from './AddOrganizationDialog';
import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';

export const AdminAllOrganizations = ({ groups, loadAdminData }) => {
  useEffect(() => {
    loadAdminData();
  }, [loadAdminData]);

  return (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>Admin</Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>Organizations</Breadcrumb.Section>
      </Breadcrumb>

      <Menu borderless>
        <Menu.Item header>
          <Icon name="building outline" />
          Organizations
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <AddOrganizationDialog />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Card fluid>
        <Card.Content>
          <List selection verticalAlign="middle" divided>
            {groups.map(group => (
              <List.Item key={group.id}>
                <Link to={'/admin/organization/' + group.id}>
                  <List.Content>
                    <List.Icon name="building outline" />
                    {group.name}
                  </List.Content>
                </Link>
              </List.Item>
            ))}
          </List>
        </Card.Content>
      </Card>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  groups: selectors.getAdminGroups(state),
});

const mapDispatchToProps = dispatch => ({
  loadAdminData: bindActionCreators(actions.admin.loadAdminData, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminAllOrganizations);
